<template>
<div class="chapter">
<div class="inner_page">
<p class="pn" id="pt2"><span class="epub-sc">PART TWO</span></p>
<p class="pt">The <span class="epub-i">Other</span> Pirates of<br/>the Caribbean</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part2.vue?23f498fd